import {
  Typography,
  Box,
  Toolbar,
  AppBar,
  Grid,
  Tabs,
  Tab,
  IconButton,
  Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectTab, removeTab } from '../../redux-store/tabSlice';
import CustomSnackbar from '../Common/CustomSnackbar';
// Constants
import { ResourceTypes } from '../../config/constants';

const CollectionNavbar = ({
  onCollectionClick,
  onFolderClick,
  onEntityClick,
  addNewRequestToResource,
  setIsUserInitiatedTabChange,
}) => {
  const dispatch = useDispatch();
  const { tabs, activeTabId } = useSelector((state) => state.tabs);
  const activeTabIndex = tabs.findIndex((tab) => tab.id === activeTabId);
  const selectedSidebarState = useSelector(
    (state) => state.user.selectedSidebarState
  );
  const [activeTab, setActiveTab] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  useEffect(() => {
    if (selectedSidebarState) {
      // Find the index of the selectedSidebarState in the tabs array
      const index = tabs.findIndex((tab) => tab.id === selectedSidebarState.id);
      // If the selectedSidebarState is found in the tabs array, set it as the active tab
      if (index !== -1) {
        setActiveTab(index);
      }
    }
  }, [selectedSidebarState, tabs]);

  const closeSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleTabChange = (event, newValue) => {
    const tabId = tabs[newValue].id;
    if (tabId) selectTab(tabId);
  };

  const handleTabClick = (tab) => {
    dispatch(selectTab(tab?.id));

    if (!tab?.resource) return;

    let type = tab?.resource?.type;

    if (!type && (tab.resource?.collection_id || tab.resource?.folder_id)) {
      type = "entity";
    }

    switch (type) {
      case ResourceTypes.COLLECTION:
        const { resource: collection } = tab;

        onCollectionClick({ collection });
        break;
      case ResourceTypes.FOLDER:
        const { resource: folder } = tab;

        onFolderClick({
          folder,
          collection: folder.collection,
          withLoading: false,
        });
        break;
      case ResourceTypes.ENTITY:
        const { resource: entity } = tab;

        onEntityClick({
          entity,
          folder: entity.folder,
          collection: entity.collection,
          withLoading: false,
        });
        break;
    }
  };

  const handleNewTabClick = () => {
    setIsUserInitiatedTabChange(true);
    addNewRequestToResource();
  };

  const handleCloseTabClick = (event, index) => {
    event.stopPropagation();

    const isClosingActiveTab = index === activeTab;
    const nextActiveTabIndex = index === tabs.length - 1 ? index - 1 : index;
    const nextActiveTab = tabs[nextActiveTabIndex] || null;

    dispatch(removeTab(tabs[index].id));

    if (isClosingActiveTab && nextActiveTab) {
      setActiveTab(nextActiveTabIndex);
      dispatch(selectTab(nextActiveTab));
    } else if (index < activeTab) {
      setActiveTab(activeTab - 1);
    }

    if (!nextActiveTab) {
      setActiveTab(0);
      dispatch(selectTab({}));
    }
  };

  return (
    <Box sx={{ flexGrow: 1 }} style={{ width: '100%' }}>
      <AppBar
        position="static"
        style={{ boxShadow: 'none', background: 'var(--background-primary)' }}
      >
        <Toolbar
          variant="dense"
          style={{ padding: 0, height: '37px', minHeight: '37px' }}
        >
          <Grid container style={{ border: '1px solid var(--borderColor)' }}>
            <Tabs
              variant="scrollable"
              value={activeTabIndex}
              onChange={handleTabChange}
              indicatorColor="primary"
              textColor="inherit"
              sx={{
                maxWidth: 'calc(100% - 50px)',
                marginLeft: 0,
                minHeight: '37px',
                height: '37px',
                backgroundColor: 'var(--background-primary)',
                borderLeft: 'none',
                '& .MuiTab-root': {
                  minHeight: '37px',
                  height: '37px',
                  borderRight: '1px solid var(--borderColor)',
                  cursor: 'default',
                  width: "150px"
                },
                '& .Mui-selected': {
                  minHeight: '37px',
                  height: '37px',
                },
              }}
            >
              {tabs?.map((tab, index) => (
                <Tab
                  key={tab?.id}
                  // onClick={() => handleTabClick(tab)}
                  label={
                    <Tooltip title={tab?.name} placement='bottom'>
                      <Box sx={{ display: 'flex', alignItems: 'center', width: "100%", justifyContent: "space-between" }}>
                        <Typography sx={{ 
                          fontSize: '12px', 
                          fontWeight: "500", 
                          color: activeTabIndex === index ? "var(--primary-color)" : 'var(--text-primary)', 
                          textTransform: "none",
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          maxWidth: '120px'
                        }}>
                          {tab?.name}
                        </Typography>
                        <div
                          style={{ padding: '5px', fontSize: '13px', cursor: 'pointer' }}
                          color="inherit"

                          onClick={(event) => handleCloseTabClick(event, index)}
                        >
                          <CloseIcon fontSize="13px" />
                        </div>
                      </Box>
                    </Tooltip>
                  }
                  sx={{
                    color: 'var(--text-primary)',
                    px: 1,
                    paddingRight: 0
                  }}
                />
              ))}
            </Tabs>
            <Tooltip title="Add Entity/Request" placement="top-start">
              <IconButton color="lightgrey" onClick={handleNewTabClick} >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        </Toolbar>
      </AppBar>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={closeSnackbar}
        message="Please select a collection or folder first!"
        severity="warning"
      />
    </Box>
  );
};

export default CollectionNavbar;
